import * as React from 'react'
import { FC } from 'react'
import { Link } from 'gatsby'

import { cls, tagUrlify } from '../../utils/utils'

import { ITagsProps } from './Tags.types'
import styles from './Tags.module.scss'

const Tags: FC<ITagsProps> = ({ tags, nowrapTag, className, selectedTag = '' }) => {
  const selected = tags.find((tag) => tagUrlify(tag) === tagUrlify(selectedTag))
  return (
    <div className={cls(styles.tags, nowrapTag && styles.nowrapTag)}>
      {selectedTag && selected ? (
        <Link
          to={`/news/`}
          className={cls('text--button', styles.tag, styles.singleTag, className)}
          onClick={() => {
            // reset page state when we are moving from tag to news page
            localStorage.removeItem('pageState')
            localStorage.removeItem('scrollState')
            localStorage.setItem('currentPage', JSON.stringify({ isTagPage: false }))
          }}
        >
          #{selected}&nbsp;&#10005;
        </Link>
      ) : (
        tags.map((tag) => (
          <Link
            to={`/news/${tagUrlify(tag)}/`}
            key={tag}
            className={cls('text--button', styles.tag, className)}
            onClick={() => {
              // reset page state when we are moving from news to tag page
              localStorage.removeItem('pageState')
              localStorage.removeItem('scrollState')
              localStorage.setItem('currentPage', JSON.stringify({ isTagPage: true }))
            }}
          >
            #{tag}
          </Link>
        ))
      )}
    </div>
  )
}

export default Tags
